<template>
  <div class="setting">
    <navigation-bar Close/>
      <div class="tabs">
        <div :class="{active: activeName === 'first'}" @click="activeName = 'first'">顯示設定</div>
        <div :class="{active: activeName === 'second'}" @click="activeName = 'second'">推播設定</div>
        <div :class="{active: activeName === 'third'}" @click="activeName = 'third'">授權管理</div>
      </div>
      <div class="tab-body main pb-4">
        <display-setting v-if="activeName === 'first'" />
        <push-setting v-if="activeName === 'second'"/>
        <authorization v-if="activeName === 'third'" />
      </div>
  </div>
</template>

<script>
import Authorization from '@/views/more/setting/components/Authorization.vue'
import DisplaySetting from '@/views/more/setting/components/DisplaySetting.vue'
import PushSetting from '@/views/more/setting/components/PushSetting.vue'

export default {
  name: "AppSetting",
  components:{ Authorization, DisplaySetting, PushSetting },
  data() {
    return {
      activeName: 'third'
    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped src="../../../less/appSetting.less"/>